import React from "react";
import DataGrid from './data-grid';
import { Tooltip } from '@progress/kendo-react-tooltip';
import Trend from "./trend";
export default class ActivityProductGrid extends React.Component {
  render() {
    var data = this.props.data;
    var comparison = this.props.comparison;
    var columns = [{
      field: 'imageLink',
      title: 'Image',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var imageLink = row.imageLink;
        var split = imageLink.split('?');
        var imageSrc = split[0] + '?width=50';
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
          src: imageSrc,
          onError: ({
            currentTarget
          }) => {
            currentTarget.onerror = null;
            currentTarget.src = 'https://s3.amazonaws.com/app.plunk.io/images/image-404.png';
          }
        })));
      }
    }, {
      field: 'title',
      title: 'Title',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Tooltip, {
          anchorElement: "target",
          position: "top"
        }, /*#__PURE__*/React.createElement("a", {
          href: row.link,
          target: "_blank",
          title: row.title
        }, row.title)));
      }
    }, {
      field: 'productId',
      title: 'Sku',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis"
        }, row.productId));
      }
    }, {
      field: 'views',
      title: 'Views',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x.productId === row.productId);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, row.views), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.views,
          data: row.views
        })));
      }
    }, {
      field: 'uniqueUsers',
      title: 'Unique Users',
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x.productId === row.productId);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, row.uniqueUsers), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.uniqueUsers,
          data: row.uniqueUsers
        })));
      }
    }, {
      field: 'conversions',
      title: 'Conversions',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x.productId === row.productId);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, row.conversions), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.conversions,
          data: row.conversions
        })));
      }
    }, {
      field: 'engagements',
      title: 'Interactions',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        var compare = comparison.find(x => x.productId === row.productId);
        if (!compare) compare = {};
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "flex-box"
        }, /*#__PURE__*/React.createElement("span", null, row.engagements), /*#__PURE__*/React.createElement(Trend, {
          compare: compare.engagements,
          data: row.engagements
        })));
      }
    }];
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}